import { render, staticRenderFns } from "./ContractSuppliersTable.vue?vue&type=template&id=f8e01d42&scoped=true&lang=pug&"
import script from "./ContractSuppliersTable.vue?vue&type=script&lang=ts&"
export * from "./ContractSuppliersTable.vue?vue&type=script&lang=ts&"
import style0 from "./ContractSuppliersTable.vue?vue&type=style&index=0&id=f8e01d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e01d42",
  null
  
)

export default component.exports